import { action, observable } from 'mobx'
import { validationContext, func, required } from 'validx'
import { vif } from 'utils/validx-validators'
import { containsOnlyValidPhoneNumberChars } from '@taxfyle/web-commons/lib/utils/phoneNumberValidationUtil'
import { asNumber } from '@taxfyle/web-commons/lib/utils/numberUtil'

const DEFAULT_TOTAL_REQUIRED_QUESTIONS = 3

export default class CallCenterConfigViewModel {
  @observable enabled = false
  @observable phoneNumber = ''
  @observable totalRequiredQuestions = DEFAULT_TOTAL_REQUIRED_QUESTIONS

  validation = validationContext(this, {
    phoneNumber: [
      vif(() => this.enabled, [
        required(),
        func(
          (opts) => containsOnlyValidPhoneNumberChars(opts.value),
          'Please enter a valid phone number'
        ),
      ]),
    ],
    totalRequiredQuestions: [
      vif(() => this.enabled, [
        required(),
        func((opts) => opts.value > 0, 'Must be greater than 0'),
      ]),
    ],
  })

  activate(callCenterConfig) {
    this.enabled = callCenterConfig?.enabled || false
    this.phoneNumber = callCenterConfig?.phone_number || ''
    this.totalRequiredQuestions =
      callCenterConfig?.total_required_questions ??
      DEFAULT_TOTAL_REQUIRED_QUESTIONS
  }

  @action.bound
  setEnabled(value) {
    this.enabled = value
  }

  @action.bound
  setPhoneNumber(value) {
    this.phoneNumber = value
  }

  @action.bound
  setTotalRequiredQuestions(value) {
    this.totalRequiredQuestions = value
  }

  toJSON() {
    return {
      enabled: this.enabled,
      phone_number: this.phoneNumber,
      total_required_questions: asNumber(this.totalRequiredQuestions),
    }
  }
}
